(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name SinglepacienteController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('SinglepacienteController', SinglepacienteController);

    SinglepacienteController.$inject = ["GenerallabService","AnimalesService","$timeout","$location",'$anchorScroll'];

    function SinglepacienteController(GenerallabService,AnimalesService,$timeout,$location,$anchorScroll)
    {

    	var vm = this;
        vm.animal = {info:{},muestras:[]};
        vm.loadingFicha = false;
        vm.loadingGuardar = false;
        vm.editar = false;
        vm.newAnimal = {};
        vm.muestro = [];
        vm.categoriasEspecies = [];
        
        vm.codeGuardar = 0;
        
        vm.generalLab = GenerallabService;

        vm.generalLab.optionsEspecies.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              categoriaespecie: vm.newAnimal.categoriaespecie_id,
              per_page: 20
            };
        };
        vm.generalLab.optionsRaces.ajax.data = function (params) {
            return {
              q: params.term, // search term
              page: params.page,
              lang_id: lang_id,
              especieseleccionada: (angular.isDefined(vm.newAnimal.especie_id) ? vm.newAnimal.especie_id : ''),
              per_page: 20
            };
        };



        vm.editarFicha = function(res){
            vm.codeGuardar = 0;
            vm.editar = res;
        }
        vm.cancelarEditar = function(){
            vm.editar = false;
        }

        vm.comprobarParams = function(){
            var url_string = $window.location.href; 
            var url = new URL(url_string);
            vm.params = url.searchParams;
        }

        vm.guardarpaciente = function(){
            vm.loadingGuardar = true;
            //console.log(vm.newAnimal);
            //console.log(vm.fecha_nac);
            AnimalesService.guardarPaciente(vm.newAnimal,function(data){
                $timeout(function(){
                    vm.animal.info = data.nuevoAnimal;
                    vm.loadingGuardar = false;
                    vm.codeGuardar = data.code;
                    vm.editar = false;

                })
                
            });
        }

        vm.yearsDiff = function(d1, d2) {
            let date1 = new Date(d1);
            let date2 = new Date(d2);
            let yearsDiff =  date2.getFullYear() - date1.getFullYear();
            return yearsDiff;
        }

        vm.getCategoriasEspecies = function(){
            AnimalesService.getCategoriasEspecies(function(data){
                vm.categoriasEspecies = data.categoriasEspecies;
            });
        }
    	vm.init = function(id_animal){
            vm.loadingFicha = true;
            AnimalesService.getAnimalById(id_animal,function(data){
                vm.animal.info = data.animal;
                vm.newAnimal = angular.copy(data.animal);
                vm.animal.muestras = data.muestras;
                vm.loadingFicha = false;

                vm.generalLab.optionsEspecies.initSelection = function (element, callback) {
                    /*var $newOption = $("<option selected='selected'></option>").val(vm.animal.info.especie.id).text(vm.animal.info.especie.nombre);
                    element.append($newOption);*/
                    if(angular.isDefined(vm.animal.info.especie)){
                        callback({id: vm.animal.info.especie.id, text: vm.animal.info.especie.nombre });
                    }
                };
                vm.generalLab.optionsRaces.initSelection = function (element, callback) {
                    //var $newOption = $("<option selected='selected'></option>").val(vm.animal.info.raza_m.id).text(vm.animal.info.raza_m.nombre);
                    //element.append($newOption);
                    if(angular.isDefined(vm.animal.info.raza_m)){
                        callback({id: vm.animal.info.raza_m.id, text: vm.animal.info.raza_m.nombre });
                    }
                };
                vm.generalLab.optionsSexo.initSelection = function (element, callback) {
                    //var $newOption = $("<option selected='selected'></option>").val(vm.animal.info.sexo.id).text(vm.animal.info.sexo.nombre);
                    //element.append($newOption);
                    callback({id: vm.animal.info.sexo.id, text: vm.animal.info.sexo.nombre });
                };
            });
    	}
               
    }


})();